// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__EZ4wi","vLegacy":"SelectSecondary_vLegacy__1S2PR","error":"SelectSecondary_error__1xJTY","disabled":"SelectSecondary_disabled__g_03z"};